<template>
	<div class="modal-popup modal-agreement">
		<div class="modal-close" @click="onClose">
			&times;
		</div>
		<div class="modal-label mt-100 mb-20">
			{{ options.label }}
		</div>
		<div class="modal-content">
			<ScrollWrapper ref="scrollWrapper" theme="portal" :content-style="{ paddingRight: '30px' }" @hasScrolledContent="toggleScrollDown" @onScroll="onScroll">
				<TheIframe :src="options.sourceUrl" @onLoad="onIframeLoad" />
			</ScrollWrapper>
		</div>
		<div class="modal-footer">
			<div v-show="iframeLoaded" ref="scrollBtn" class="scroll-down-block" @click="scrollToBottom">
				<div class="flex flex-col">
					<SVGIcon icon-name="arrow-down" />
					<SVGIcon icon-name="arrow-down" />
				</div>
				<h4 class="ml-20">
					{{ $tc('modals.agreement.footerTitle') }}
				</h4>
			</div>
			<div class="flex flex-wrap items-center justify-center">
				<Checkbox
					v-model="checkbox.value"
					:disabled="checkbox.disabled"
					:label="options.checkboxLabel"
					class="checkbox-big h4 mr-20"
				/>
				<button
					:disabled="!checkbox.value"
					:title="options.submitButtonLabel"
					class="button-pink"
					@click="onConfirm"
				>
					{{ options.submitButtonLabel }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import { SVGIcon, Checkbox, TheIframe, ScrollWrapper } from '~/components/interface'

export default {
	name: 'ModalAgreement',
	components: {
		SVGIcon,
		TheIframe,
		Checkbox,
		ScrollWrapper
	},
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			checkbox: {
				disabled: true,
				value: false
			},
			hasScrolledContent: true,
			iframeLoaded: false,
			atBottom: false
		}
	},
	methods: {
		toggleScrollDown (hasScroll) {
			this.hasScrolledContent = hasScroll
			this.toggleScrollCheckboxBtn()
		},
		scrollToBottom () {
			this.$refs.scrollWrapper.scrollToBottom(1500)
		},
		onScroll (event) {
			this.atBottom = event.process > 0.8
			this.toggleScrollCheckboxBtn()
		},
		toggleScrollCheckboxBtn () {
			this.checkbox.disabled = this.hasScrolledContent ? !this.atBottom : false

			if (this.hasScrolledContent && !this.atBottom) {
				this.$nextTick(() => {
					this.$refs.scrollBtn && this.$refs.scrollBtn.classList.remove('hidden')
				})
			} else {
				this.$nextTick(() => {
					this.$refs.scrollBtn && this.$refs.scrollBtn.classList.add('hidden')
				})
			}
		},
		onIframeLoad () {
			this.iframeLoaded = true
			this.$refs.scrollWrapper.refresh()
		}
	}
}
</script>

<style lang="scss">
	.scroll-down-block {
		cursor: pointer;
		position: absolute;
		top: -71px;
		left: 0;
		width: calc(100% - 25px);
		height: 50px;
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: center;
		transition: 0.75s;
		background-color: rgba($content-bg, 0.5);
		color: $primary;

		&:hover {
			color: $pink;
			background-color: rgba($content-bg, 1);
		}

		&.hidden {
			opacity: 0;
		}

		svg {
			opacity: 0;
			animation: scroll-down 2s infinite;

			&:nth-child(1) {
				transform: translate(0, 10px) scale(0.75);
				animation-delay: 0s
			}

			&:nth-child(2) {
				transform: translate(0, -10px) scale(0.75);
				animation-delay: 0.15s
			}
		}
	}

	@keyframes scroll-down {
		0% {
			opacity: 0.1;
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0.1;
		}
	}
</style>
